import { forwardRef } from "react";
function SvgGoogle({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#4285F4"
          d="M31.52 20.272c0-.85-.076-1.669-.218-2.454H20v4.642h6.458a5.52 5.52 0 0 1-2.394 3.621v3.011h3.878c2.269-2.089 3.578-5.165 3.578-8.82Z"
        />
        <path
          fill="#34A853"
          d="M20 32.001c3.24 0 5.956-1.074 7.942-2.907l-3.878-3.01c-1.075.72-2.45 1.145-4.064 1.145-3.125 0-5.77-2.111-6.714-4.948h-4.01v3.11A11.995 11.995 0 0 0 20 32Z"
        />
        <path
          fill="#FBBC05"
          d="M13.286 22.28a7.213 7.213 0 0 1-.377-2.28c0-.79.136-1.56.377-2.28v-3.108h-4.01A11.995 11.995 0 0 0 8 20c0 1.936.464 3.769 1.276 5.389l4.01-3.11Z"
        />
        <path
          fill="#EA4335"
          d="M20 12.773c1.762 0 3.344.605 4.587 1.794l3.442-3.441C25.951 9.189 23.235 8 20 8c-4.69 0-8.75 2.69-10.724 6.61l4.01 3.11c.943-2.836 3.589-4.947 6.714-4.947Z"
        />
      </g>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgGoogle);
export default ForwardRef;
